module.exports = __webpack_public_path__ + "img/chess_chesswhite5.924c97ca.png";